<template>
  <div class="position-relative" :id="dropdownId" role="dropdown">
    <input
      type="text"
      class="form-control"
      :class="[!isValid ? 'is-invalid' : 'is-valid']"
      v-model="search"
      :placeholder="placeholder"
      @focus="handleFocus"
      @input="dirty = true"
    />
    <div
      class="position-absolute top-100 start-0 w-100 bg-white border rounded mt-1"
      style="z-index: 1000; max-height: 200px; overflow-y: auto"
      v-if="focused"
    >
      <div
        v-for="item in filteredSuggestions"
        :key="item[objKey]"
        class="px-3 py-2 cursor-pointer hover-bg fs-6"
        @click="
          emit('update:modelValue', item);
          emit('changed');
          search = item[label];
          focused = false;
          dirty = false;
        "
      >
        {{ item[label] }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onUnmounted, ref, computed, watch } from "vue";

const focused = ref(false);
const search = ref("");
const dropdownId = `dropdown-${Math.random().toString(36).substr(2, 9)}`;

const props = defineProps({
  suggestion: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number, Object],
    default: null,
  },
  placeholder: {
    type: String,
    default: "Select",
  },
  label: {
    type: String,
    default: "label",
  },
  objKey: {
    type: String,
    default: "id",
  },
});

const emit = defineEmits(["update:modelValue", "isValid", "changed"]);

const dirty = ref(false);

const filteredSuggestions = computed(() => {
  if (!search.value || !dirty.value) {
    return props.suggestion;
  }
  return props.suggestion.filter((item) =>
    item[props.label]
      .toLowerCase()
      .includes(search.value.toString().toLowerCase())
  );
});

const isValid = computed(() => {
  return props.suggestion.find((item) => item[props.label] === search.value)
    ? true
    : false;
});

const handleFocus = () => {
  document.querySelectorAll('[role="dropdown"]').forEach((dropdown) => {
    if (dropdown.id !== dropdownId) {
      const otherDropdown = dropdown.__vueParentComponent?.ctx;
      if (otherDropdown && otherDropdown.focused) {
        otherDropdown.focused.value = false;
      }
    }
  });
  focused.value = true;
};

const handleClickOutside = (e) => {
  if (!e.target.closest(`#${dropdownId}`)) {
    focused.value = false;
  }
};

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      search.value = newVal[props.label];
    } else {
      search.value = "";
    }
  }
);

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

watch(
  isValid,
  (newVal) => {
    emit("isValid", newVal);
  },
  { immediate: true }
);
</script>
<style scoped>
.hover-bg:hover {
  background-color: #ffe7e7;
}
</style>
